// extracted by mini-css-extract-plugin
export var label = "_8t-1";
export var reminder = "_8t-0";